import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { NgxMaskPipe } from 'ngx-mask';
import { InputAutocomplete } from '../../models/input-autocomplete';

@Component({
  selector: 'postal-zone-input',
  templateUrl: './postal-zone-input.component.html',
  styleUrls: ['./postal-zone-input.component.scss']
})
export class PostalZoneInputComponent implements OnInit {
  @Input() id: string;
  @Input() form: UntypedFormControl;
  @Input() placeholder: string;
  @Input() label: string;
  @Input() tabindex = 0;
  @Input() refreshPipe: boolean;
  @Input() set country(value: string) {
    this._country = value;
    this.updateFormOnCountryChange(value);
  }

  get country(): string {
    return this._country;
  }

  private _country: string;
  private init: boolean = true;
  readonly autocomplete = InputAutocomplete.POSTAL_CODE;

  get postalZoneMask(): string {
    if (this._country === 'PL') {
      return '00-000';
    }
    return null;
  }

  constructor(private maskPipe: NgxMaskPipe,
              private changeDetectorRef: ChangeDetectorRef) { }

  private updateFormOnCountryChange(country: string): void {
    if (country !== 'PL' && !this.init) {

      /**looks like ngx-mask keeps masked_value + last_key_from_input,
       * form.setValue(this.form.value) refresh value in view
       */
      this.form.setValue(this.form.value);
    } else if (country === 'PL' && this.form.value) {
      const formatted = this.maskPipe.transform(this.form.value, this.postalZoneMask);
      this.form.setValue(formatted);
    }

    this.changeDetectorRef.detectChanges();
  }

  ngOnInit() {
    this.validateInputs();
    this.init = false;
  }

  private validateInputs(): void {
    if (!this.id) {
      console.error('Input id wasn\'t specified', this);
    }

    if (this.form == null) {
      throw Error('FormControl passed to postal-zone-input is null');
    }
  }
}
